// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table-training-image img{width:5rem}`, "",{"version":3,"sources":["webpack://./src/Pages/Training/AddTrainingImage/AddTrainingImage.style.scss"],"names":[],"mappings":"AACC,yBACC,UAAA","sourcesContent":["table-training-image {\n & img {\n  width: 5rem;\n }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
